import React from 'react';
import PropTypes from 'prop-types';
import { pick } from 'lodash';

import FileStackImage from 'misc/filestack_image';
import CertificationBadge from 'components/CertificationBadge';
import CertificationOverviewDetailsBlock from './CertificationOverviewDetailsBlock';

const CertificationOverviewHeader = ({
  title,
  description,
  assignment,
  certification,
  image,
  contents,
  estimatedMinutesToComplete,
  toggleCertificateModal,
  isComplete,
  showCertificateModalInPreview,
  hasHiddenContents,
}) => {
  let filestackImage = null;
  if (image) {
    filestackImage = new FileStackImage({
      ...pick(image, ['signature', 'policy', 'handle']),
      transform: {
        resize: {
          fit: 'crop',
          align: 'center',
          height: 280,
          width: 1000,
        },
      },
    });
  }

  return (
    <div className="CertificationOverviewHeader pb-32 mb-32 bdrs-small bg-white">
      {image && (
        <img
          className="CertificationOverviewHeader-image w-fill"
          src={image.bssSignedUrl || filestackImage.url}
          alt={image.name}
        />
      )}
      <div className="pl-32 pt-32 pr-32 d-f ai-c">
        <CertificationBadge
          iconName={certification.iconName}
          height={40}
          width={32}
          foregroundColor={certification.foregroundColor}
          backgroundColor={certification.backgroundColor}
          image={certification.image}
        />
        <span className="ml-20 ff-ss wb-bw wr-bw CertificationOverviewHeader-title">
          {title}
        </span>
        {!hasHiddenContents && isComplete && showCertificateModalInPreview && (
          <button
            type="button"
            className="u-resetBtn h-td-u ml-a c-brand-blue fz-bigger"
            onClick={toggleCertificateModal}
          >
            {t('certifications.certificate.view_certificate')}
          </button>
        )}
      </div>
      <CertificationOverviewDetailsBlock
        assignment={assignment}
        estimatedMinutesToComplete={estimatedMinutesToComplete}
        contents={contents}
        description={description}
        certificationId={certification.id}
      />
    </div>
  );
};

CertificationOverviewHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  assignment: PropTypes.shape({
    dueDate: PropTypes.string,
  }),
  certification: PropTypes.shape({
    iconName: PropTypes.string,
    foregroundColor: PropTypes.string,
    backgroundColor: PropTypes.string,
  }).isRequired,
  image: PropTypes.shape({
    signature: PropTypes.string,
    policy: PropTypes.string,
    handle: PropTypes.string,
  }),
  contents: PropTypes.arrayOf(PropTypes.object),
  estimatedMinutesToComplete: PropTypes.number,
  hasHiddenContents: PropTypes.bool,
};

export default CertificationOverviewHeader;
